export default __webpack_public_path__ + "static/media/client10.fe0a28a4.jpg";